import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import 'sde-client/styles/app.scss'

import { Intersect } from 'vuetify/directives'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives: { ...directives, Intersect },
  display: {
    mobileBreakpoint: 'md'
  },
  defaults: {
    VSelect: {
      menuProps: {
        maxHeight: 300,
        offset: 4
      }
    },
    VAutocomplete: {
      menuProps: {
        maxHeight: 300,
        offset: 4
      }
    },
    VCombobox: {
      menuProps: {
        maxHeight: 300,
        offset: 4
      }
    }
  },
  theme: {
    defaultTheme: 'sdeLight',
    themes: {
      sdeLight: {
        dark: false,
        colors: {
          primary: '#0c82c0',
          secondary: '#0C3D91',
          accent: '#0C3D91',
          success: '#76B82a'
        }
      }
    }
  }
})
